var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"to-live-map-button cursor-pointer",on:{"click":_vm.handleClick}},[_c('div',{staticClass:"menu-icon-button"},[_c('span',{staticClass:"menu-icon"}),_c('span',[_vm._v(_vm._s(_vm.buttonText))])])])}
var staticRenderFns = []

export { render, staticRenderFns }